import { connect } from 'react-redux';
import {
  FLAG_VARIABLE_RESOLUTION
} from 'constants/FeatureFlags';
import UserSettings from 'components/SettingsModal/UserSettings';
import { currentUserSelectors, mediaSelectors, featureSelectors } from '@lifesize/nucleus';

const mapStateToProps = state =>
  ({
    userProfile: currentUserSelectors.myInfo(state),
    hasCamera: !!mediaSelectors.videoDevices(state).length,
    hasMicrophone: !!mediaSelectors.audioDevices(state).length,
    showQualityDropdown: featureSelectors.getFeatureFlag(state)(FLAG_VARIABLE_RESOLUTION)
  });

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings);
